import { WATERMARK_TYPE } from '../../reducers/serviceSettings';

export class WatermarkLabel {
  private static readonly labels = {
    [WATERMARK_TYPE.NONE]: '未設定',
    [WATERMARK_TYPE.INDIVIDUAL_INPUT]: '個別入力',
    [WATERMARK_TYPE.CORPORATE_LOGO]: '企業ロゴ'
  } as const;

  static get(key: keyof typeof WatermarkLabel.labels): string {
    return this.labels[key];
  }
}

export const watermarkRadioButtons = [
  { type: WATERMARK_TYPE.NONE, label: WatermarkLabel.get(WATERMARK_TYPE.NONE) },
  { type: WATERMARK_TYPE.INDIVIDUAL_INPUT, label: WatermarkLabel.get(WATERMARK_TYPE.INDIVIDUAL_INPUT) },
  { type: WATERMARK_TYPE.CORPORATE_LOGO, label: WatermarkLabel.get(WATERMARK_TYPE.CORPORATE_LOGO) }
] as const;
